// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/authz/v1/authz.proto (package mono.authz.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse, Principal, Resource } from "../../common/v1/types_pb";
/**
 * CheckRequest is a single authorization check.
 *
 * @generated from message mono.authz.v1.CheckRequest
 */ export class CheckRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.Principal principal = 1;
   */ _define_property(this, "principal", void 0), /**
   * @generated from field: mono.common.v1.Resource resource = 2;
   */ _define_property(this, "resource", void 0), /**
   * @generated from field: string action = 3;
   */ _define_property(this, "action", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckRequest, "runtime", proto3);
_define_property(CheckRequest, "typeName", "mono.authz.v1.CheckRequest");
_define_property(CheckRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "principal",
            kind: "message",
            T: Principal
        },
        {
            no: 2,
            name: "resource",
            kind: "message",
            T: Resource
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CheckResponse is the result of an authorization check.
 *
 * @generated from message mono.authz.v1.CheckResponse
 */ export class CheckResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool allowed = 1;
   */ _define_property(this, "allowed", false), /**
   * @generated from field: string policy_id = 2;
   */ _define_property(this, "policyId", ""), /**
   * @generated from field: google.protobuf.Struct metadata = 3;
   */ _define_property(this, "metadata", void 0), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: google.protobuf.Timestamp checked_at = 5;
   */ _define_property(this, "checkedAt", void 0), /**
   * @generated from field: repeated string validation_errors = 6;
   */ _define_property(this, "validationErrors", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckResponse, "runtime", proto3);
_define_property(CheckResponse, "typeName", "mono.authz.v1.CheckResponse");
_define_property(CheckResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "allowed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "policy_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "metadata",
            kind: "message",
            T: Struct
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "checked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "validation_errors",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * BatchCheckRequest contains multiple authorization checks.
 *
 * @generated from message mono.authz.v1.BatchCheckRequest
 */ export class BatchCheckRequest extends Message {
    static fromBinary(bytes, options) {
        return new BatchCheckRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BatchCheckRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BatchCheckRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BatchCheckRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.CheckRequest checks = 1;
   */ _define_property(this, "checks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BatchCheckRequest, "runtime", proto3);
_define_property(BatchCheckRequest, "typeName", "mono.authz.v1.BatchCheckRequest");
_define_property(BatchCheckRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checks",
            kind: "message",
            T: CheckRequest,
            repeated: true
        }
    ]));
/**
 * BatchCheckResponse contains results for multiple authorization checks.
 *
 * @generated from message mono.authz.v1.BatchCheckResponse
 */ export class BatchCheckResponse extends Message {
    static fromBinary(bytes, options) {
        return new BatchCheckResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BatchCheckResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BatchCheckResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BatchCheckResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.CheckResponse results = 1;
   */ _define_property(this, "results", []), /**
   * @generated from field: string request_id = 2;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: google.protobuf.Timestamp checked_at = 3;
   */ _define_property(this, "checkedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BatchCheckResponse, "runtime", proto3);
_define_property(BatchCheckResponse, "typeName", "mono.authz.v1.BatchCheckResponse");
_define_property(BatchCheckResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: CheckResponse,
            repeated: true
        },
        {
            no: 2,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "checked_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * GetPoliciesRequest requests loaded policies.
 *
 * @generated from message mono.authz.v1.GetPoliciesRequest
 */ export class GetPoliciesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPoliciesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPoliciesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPoliciesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPoliciesRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPoliciesRequest, "runtime", proto3);
_define_property(GetPoliciesRequest, "typeName", "mono.authz.v1.GetPoliciesRequest");
_define_property(GetPoliciesRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * GetPoliciesResponse contains the list of loaded policies.
 *
 * @generated from message mono.authz.v1.GetPoliciesResponse
 */ export class GetPoliciesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPoliciesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPoliciesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPoliciesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPoliciesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.PolicyInfo policies = 1;
   */ _define_property(this, "policies", []), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: bool cerbos_connected = 4;
   */ _define_property(this, "cerbosConnected", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPoliciesResponse, "runtime", proto3);
_define_property(GetPoliciesResponse, "typeName", "mono.authz.v1.GetPoliciesResponse");
_define_property(GetPoliciesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "policies",
            kind: "message",
            T: PolicyInfo,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cerbos_connected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * PolicyInfo describes a loaded authorization policy.
 *
 * @generated from message mono.authz.v1.PolicyInfo
 */ export class PolicyInfo extends Message {
    static fromBinary(bytes, options) {
        return new PolicyInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PolicyInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PolicyInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PolicyInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string version = 2;
   */ _define_property(this, "version", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string updated_at = 6;
   */ _define_property(this, "updatedAt", ""), /**
   * @generated from field: repeated string resource_kinds = 7;
   */ _define_property(this, "resourceKinds", []), /**
   * @generated from field: repeated string actions = 8;
   */ _define_property(this, "actions", []), /**
   * @generated from field: bool enabled = 9;
   */ _define_property(this, "enabled", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PolicyInfo, "runtime", proto3);
_define_property(PolicyInfo, "typeName", "mono.authz.v1.PolicyInfo");
_define_property(PolicyInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "resource_kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * CreatePolicyRequest creates a new policy from YAML.
 *
 * @generated from message mono.authz.v1.CreatePolicyRequest
 */ export class CreatePolicyRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePolicyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePolicyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePolicyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePolicyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string yaml = 2;
   */ _define_property(this, "yaml", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePolicyRequest, "runtime", proto3);
_define_property(CreatePolicyRequest, "typeName", "mono.authz.v1.CreatePolicyRequest");
_define_property(CreatePolicyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "yaml",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * UpdatePolicyRequest updates an existing policy.
 *
 * @generated from message mono.authz.v1.UpdatePolicyRequest
 */ export class UpdatePolicyRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePolicyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePolicyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePolicyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePolicyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string yaml = 2;
   */ _define_property(this, "yaml", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePolicyRequest, "runtime", proto3);
_define_property(UpdatePolicyRequest, "typeName", "mono.authz.v1.UpdatePolicyRequest");
_define_property(UpdatePolicyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "yaml",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CreatePolicyResponse is returned after a policy creation.
 *
 * @generated from message mono.authz.v1.CreatePolicyResponse
 */ export class CreatePolicyResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePolicyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePolicyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePolicyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePolicyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false), /**
   * @generated from field: mono.authz.v1.PolicyInfo policy = 2;
   */ _define_property(this, "policy", void 0), /**
   * @generated from field: string message = 3;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePolicyResponse, "runtime", proto3);
_define_property(CreatePolicyResponse, "typeName", "mono.authz.v1.CreatePolicyResponse");
_define_property(CreatePolicyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "policy",
            kind: "message",
            T: PolicyInfo
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * UpdatePolicyResponse is returned after a policy update.
 *
 * @generated from message mono.authz.v1.UpdatePolicyResponse
 */ export class UpdatePolicyResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePolicyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePolicyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePolicyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePolicyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false), /**
   * @generated from field: mono.authz.v1.PolicyInfo policy = 2;
   */ _define_property(this, "policy", void 0), /**
   * @generated from field: string message = 3;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePolicyResponse, "runtime", proto3);
_define_property(UpdatePolicyResponse, "typeName", "mono.authz.v1.UpdatePolicyResponse");
_define_property(UpdatePolicyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "policy",
            kind: "message",
            T: PolicyInfo
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DeletePolicyRequest removes a policy by ID.
 *
 * @generated from message mono.authz.v1.DeletePolicyRequest
 */ export class DeletePolicyRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeletePolicyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePolicyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePolicyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePolicyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePolicyRequest, "runtime", proto3);
_define_property(DeletePolicyRequest, "typeName", "mono.authz.v1.DeletePolicyRequest");
_define_property(DeletePolicyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DeletePolicyResponse confirms policy deletion.
 *
 * @generated from message mono.authz.v1.DeletePolicyResponse
 */ export class DeletePolicyResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeletePolicyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePolicyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePolicyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePolicyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePolicyResponse, "runtime", proto3);
_define_property(DeletePolicyResponse, "typeName", "mono.authz.v1.DeletePolicyResponse");
_define_property(DeletePolicyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ValidatePolicyRequest validates policy YAML.
 *
 * @generated from message mono.authz.v1.ValidatePolicyRequest
 */ export class ValidatePolicyRequest extends Message {
    static fromBinary(bytes, options) {
        return new ValidatePolicyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatePolicyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatePolicyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatePolicyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string yaml = 1;
   */ _define_property(this, "yaml", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ValidatePolicyRequest, "runtime", proto3);
_define_property(ValidatePolicyRequest, "typeName", "mono.authz.v1.ValidatePolicyRequest");
_define_property(ValidatePolicyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "yaml",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ValidatePolicyResponse contains validation results.
 *
 * @generated from message mono.authz.v1.ValidatePolicyResponse
 */ export class ValidatePolicyResponse extends Message {
    static fromBinary(bytes, options) {
        return new ValidatePolicyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatePolicyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatePolicyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatePolicyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool valid = 1;
   */ _define_property(this, "valid", false), /**
   * @generated from field: repeated string errors = 2;
   */ _define_property(this, "errors", []), /**
   * @generated from field: repeated string warnings = 3;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: string policy_id = 4;
   */ _define_property(this, "policyId", ""), /**
   * @generated from field: string resource_kind = 5;
   */ _define_property(this, "resourceKind", ""), /**
   * @generated from field: string message = 6;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string request_id = 7;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ValidatePolicyResponse, "runtime", proto3);
_define_property(ValidatePolicyResponse, "typeName", "mono.authz.v1.ValidatePolicyResponse");
_define_property(ValidatePolicyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "valid",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "errors",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "policy_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "resource_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ResolveRequest mirrors a Check shape but optionally carries scope-bound
 * resource attrs (object_type + object_id are the soft-FK scope_node
 * target). The principal field is the same shape as CheckRequest's;
 * service.go threads the JWT principal in.
 *
 * @generated from message mono.authz.v1.ResolveRequest
 */ export class ResolveRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.Principal principal = 1;
   */ _define_property(this, "principal", void 0), /**
   * @generated from field: mono.common.v1.Resource resource = 2;
   */ _define_property(this, "resource", void 0), /**
   * @generated from field: string action = 3;
   */ _define_property(this, "action", ""), /**
   * object_type maps to a pangaea scope_node target_object_type (e.g.
   * "delivery.programs"). object_id is the row id. Empty values are
   * tolerated — the resolver treats them as "no scope-narrow" and the
   * PolicyResult falls back to broader assignments.
   *
   * @generated from field: string object_type = 4;
   */ _define_property(this, "objectType", ""), /**
   * @generated from field: string object_id = 5;
   */ _define_property(this, "objectId", ""), /**
   * sensitivity is an optional resource attribute. Free string on the wire
   * so tenants/policies can add values without a proto change; the canonical
   * values the spine recognises are:
   *   standard | restricted
   *   legal_privileged | source_selection_sensitive | protective_order
   * The latter three are the Phase 3c legal lane (vision §9/§13): the
   * resolver enforces them as a hard boundary — NoView for non-legal
   * principals and AuditRequired on every access. Resource policies match on
   * this for the view-mode-downgrade / deny flow.
   *
   * @generated from field: string sensitivity = 6;
   */ _define_property(this, "sensitivity", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRequest, "runtime", proto3);
_define_property(ResolveRequest, "typeName", "mono.authz.v1.ResolveRequest");
_define_property(ResolveRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "principal",
            kind: "message",
            T: Principal
        },
        {
            no: 2,
            name: "resource",
            kind: "message",
            T: Resource
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sensitivity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ResolvedPolicy mirrors the resolver.PolicyResult Go shape.
 *
 * @generated from message mono.authz.v1.ResolvedPolicy
 */ export class ResolvedPolicy extends Message {
    static fromBinary(bytes, options) {
        return new ResolvedPolicy().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvedPolicy().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvedPolicy().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvedPolicy, a, b);
    }
    constructor(data){
        super(), /**
   * allow | deny
   *
   * @generated from field: string decision = 1;
   */ _define_property(this, "decision", ""), /**
   * full | simplified | masked | no_view | action_blocked
   *
   * @generated from field: string view_mode = 2;
   */ _define_property(this, "viewMode", ""), /**
   * @generated from field: repeated string masked_fields = 3;
   */ _define_property(this, "maskedFields", []), /**
   * @generated from field: repeated string action_blocked = 4;
   */ _define_property(this, "actionBlocked", []), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string matched_policy_id = 6;
   */ _define_property(this, "matchedPolicyId", ""), /**
   * @generated from field: bool audit_required = 7;
   */ _define_property(this, "auditRequired", false), /**
   * Whether the requested action is in a matched bundle's permitted_actions
   * baseline. Cerbos stays authoritative on allow/deny; this surfaces the
   * bundle baseline so capability-style consumers (e.g. ryugu's
   * GetProgram.can_edit) can require BOTH — a coarse role-allow does not
   * grant an edit affordance the assignment's bundle never included.
   *
   * @generated from field: bool action_in_bundle = 8;
   */ _define_property(this, "actionInBundle", false), /**
   * Union of the matched bundles' permitted actions — the principal's full
   * verb set at this scope. Consumers that compare capability SETS (the
   * roster self-service subset guard) need the whole set, not one bit.
   *
   * @generated from field: repeated string granted_actions = 9;
   */ _define_property(this, "grantedActions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvedPolicy, "runtime", proto3);
_define_property(ResolvedPolicy, "typeName", "mono.authz.v1.ResolvedPolicy");
_define_property(ResolvedPolicy, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "view_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "masked_fields",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "action_blocked",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "matched_policy_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "audit_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "action_in_bundle",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "granted_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ResolveResponse carries the projection.
 *
 * @generated from message mono.authz.v1.ResolveResponse
 */ export class ResolveResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.ResolvedPolicy policy = 1;
   */ _define_property(this, "policy", void 0), /**
   * @generated from field: string request_id = 2;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 3;
   */ _define_property(this, "resolvedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveResponse, "runtime", proto3);
_define_property(ResolveResponse, "typeName", "mono.authz.v1.ResolveResponse");
_define_property(ResolveResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "policy",
            kind: "message",
            T: ResolvedPolicy
        },
        {
            no: 2,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ResolveTarget is one scope node to project in a ResolveMany batch. object_id
 * doubles as the response map key, so it must be unique within a request.
 *
 * @generated from message mono.authz.v1.ResolveTarget
 */ export class ResolveTarget extends Message {
    static fromBinary(bytes, options) {
        return new ResolveTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveTarget, a, b);
    }
    constructor(data){
        super(), /**
   * scope_node target_object_type, e.g. "delivery.programs"
   *
   * @generated from field: string object_type = 1;
   */ _define_property(this, "objectType", ""), /**
   * scope_node target_object_id (e.g. a program id)
   *
   * @generated from field: string object_id = 2;
   */ _define_property(this, "objectId", ""), /**
   * optional per-target sensitivity (see ResolveRequest)
   *
   * @generated from field: string sensitivity = 3;
   */ _define_property(this, "sensitivity", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveTarget, "runtime", proto3);
_define_property(ResolveTarget, "typeName", "mono.authz.v1.ResolveTarget");
_define_property(ResolveTarget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sensitivity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ResolveManyRequest carries one principal + action + tenant and N scope
 * targets. kind is the shared Cerbos resource kind (a rollup projects one kind
 * — e.g. "program"); per-target object_type/object_id/sensitivity ride on each
 * ResolveTarget.
 *
 * @generated from message mono.authz.v1.ResolveManyRequest
 */ export class ResolveManyRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveManyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveManyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveManyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveManyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.Principal principal = 1;
   */ _define_property(this, "principal", void 0), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string action = 3;
   */ _define_property(this, "action", ""), /**
   * tenant_id is advisory only. The resolver scopes every target to the
   * principal's own tenant (a batch can't be used to reach across tenants), so
   * this field is NOT load-bearing — do not rely on it to scope the batch.
   *
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.authz.v1.ResolveTarget targets = 5;
   */ _define_property(this, "targets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveManyRequest, "runtime", proto3);
_define_property(ResolveManyRequest, "typeName", "mono.authz.v1.ResolveManyRequest");
_define_property(ResolveManyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "principal",
            kind: "message",
            T: Principal
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "targets",
            kind: "message",
            T: ResolveTarget,
            repeated: true
        }
    ]));
/**
 * ResolveManyResponse maps object_id -> ResolvedPolicy. Every requested
 * object_id is present: a target the resolver couldn't decide fails closed to a
 * no_view ResolvedPolicy rather than being omitted, so a caller iterating the
 * map can't mistake "absent" for "allow".
 *
 * @generated from message mono.authz.v1.ResolveManyResponse
 */ export class ResolveManyResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveManyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveManyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveManyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveManyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: map<string, mono.authz.v1.ResolvedPolicy> policies = 1;
   */ _define_property(this, "policies", {}), /**
   * @generated from field: string request_id = 2;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 3;
   */ _define_property(this, "resolvedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveManyResponse, "runtime", proto3);
_define_property(ResolveManyResponse, "typeName", "mono.authz.v1.ResolveManyResponse");
_define_property(ResolveManyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "policies",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: ResolvedPolicy
            }
        },
        {
            no: 2,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.authz.v1.ResolveManyActionsRequest
 */ export class ResolveManyActionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveManyActionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveManyActionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveManyActionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveManyActionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.Principal principal = 1;
   */ _define_property(this, "principal", void 0), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * actions are decided independently; duplicates are answered once.
   *
   * @generated from field: repeated string actions = 3;
   */ _define_property(this, "actions", []), /**
   * tenant_id is advisory only, as on ResolveManyRequest.
   *
   * @generated from field: string tenant_id = 4;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.authz.v1.ResolveTarget targets = 5;
   */ _define_property(this, "targets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveManyActionsRequest, "runtime", proto3);
_define_property(ResolveManyActionsRequest, "typeName", "mono.authz.v1.ResolveManyActionsRequest");
_define_property(ResolveManyActionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "principal",
            kind: "message",
            T: Principal
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "targets",
            kind: "message",
            T: ResolveTarget,
            repeated: true
        }
    ]));
/**
 * ActionPolicies is one action's ResolveManyResponse.policies.
 *
 * @generated from message mono.authz.v1.ActionPolicies
 */ export class ActionPolicies extends Message {
    static fromBinary(bytes, options) {
        return new ActionPolicies().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionPolicies().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionPolicies().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionPolicies, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string action = 1;
   */ _define_property(this, "action", ""), /**
   * @generated from field: map<string, mono.authz.v1.ResolvedPolicy> policies = 2;
   */ _define_property(this, "policies", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(ActionPolicies, "runtime", proto3);
_define_property(ActionPolicies, "typeName", "mono.authz.v1.ActionPolicies");
_define_property(ActionPolicies, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "policies",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: ResolvedPolicy
            }
        }
    ]));
/**
 * ResolveManyActionsResponse holds one entry per requested action, each with
 * every requested object_id (fail-closed no_view rather than omitted).
 *
 * @generated from message mono.authz.v1.ResolveManyActionsResponse
 */ export class ResolveManyActionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveManyActionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveManyActionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveManyActionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveManyActionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.ActionPolicies actions = 1;
   */ _define_property(this, "actions", []), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 2;
   */ _define_property(this, "resolvedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveManyActionsResponse, "runtime", proto3);
_define_property(ResolveManyActionsResponse, "typeName", "mono.authz.v1.ResolveManyActionsResponse");
_define_property(ResolveManyActionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "actions",
            kind: "message",
            T: ActionPolicies,
            repeated: true
        },
        {
            no: 2,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * AdminRoleBundle mirrors pangaea RoleBundle but with only the fields the
 * admin UI needs. tenant_id empty = global; default_view_mode is one of
 * full|simplified|masked|no_view|action_blocked.
 *
 * @generated from message mono.authz.v1.AdminRoleBundle
 */ export class AdminRoleBundle extends Message {
    static fromBinary(bytes, options) {
        return new AdminRoleBundle().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRoleBundle().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRoleBundle().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRoleBundle, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string default_view_mode = 4;
   */ _define_property(this, "defaultViewMode", ""), /**
   * @generated from field: bool is_global = 5;
   */ _define_property(this, "isGlobal", false), /**
   * The ABAC substance: the verbs this bundle permits and which of them
   * additionally require an active break-glass grant. Surfacing these is what
   * lets the admin UI render a real permission matrix instead of opaque
   * bundle names.
   *
   * @generated from field: repeated string permitted_actions = 6;
   */ _define_property(this, "permittedActions", []), /**
   * @generated from field: repeated string requires_break_glass_for = 7;
   */ _define_property(this, "requiresBreakGlassFor", []), /**
   * Sensitive-data packs (K5): the business-readable visibility groupings
   * this bundle un-masks on its restricted views. The server owns the
   * pack→field mapping (resolver.DataPacks); the matrix expands packs via
   * AdminListDataPacks to render see-rows honestly.
   *
   * @generated from field: repeated string data_packs = 8;
   */ _define_property(this, "dataPacks", []), /**
   * Template lineage (WS2): which template family/version this role was
   * applied from — renders "from Program Lead v2" and drives the
   * "new version available" indicator. Empty for hand-built roles.
   *
   * @generated from field: string source_template_family_id = 9;
   */ _define_property(this, "sourceTemplateFamilyId", ""), /**
   * @generated from field: int32 source_template_version = 10;
   */ _define_property(this, "sourceTemplateVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRoleBundle, "runtime", proto3);
_define_property(AdminRoleBundle, "typeName", "mono.authz.v1.AdminRoleBundle");
_define_property(AdminRoleBundle, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "default_view_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "is_global",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "permitted_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "requires_break_glass_for",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "data_packs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "source_template_family_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_template_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListBundlesRequest
 */ export class AdminListBundlesRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListBundlesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListBundlesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListBundlesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListBundlesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * tenant_id empty = current tenant from the JWT. include_global=true
   * returns both tenant-scoped + global rows; defaults true so admin
   * UIs see the full catalog by default.
   *
   * @generated from field: bool include_global = 1;
   */ _define_property(this, "includeGlobal", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListBundlesRequest, "runtime", proto3);
_define_property(AdminListBundlesRequest, "typeName", "mono.authz.v1.AdminListBundlesRequest");
_define_property(AdminListBundlesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "include_global",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListBundlesResponse
 */ export class AdminListBundlesResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListBundlesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListBundlesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListBundlesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListBundlesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminRoleBundle bundles = 1;
   */ _define_property(this, "bundles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListBundlesResponse, "runtime", proto3);
_define_property(AdminListBundlesResponse, "typeName", "mono.authz.v1.AdminListBundlesResponse");
_define_property(AdminListBundlesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bundles",
            kind: "message",
            T: AdminRoleBundle,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminDataPack
 */ export class AdminDataPack extends Message {
    static fromBinary(bytes, options) {
        return new AdminDataPack().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminDataPack().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminDataPack().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminDataPack, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * Exact registry/proto field names the pack un-masks — for matrix row math.
   *
   * @generated from field: repeated string fields = 4;
   */ _define_property(this, "fields", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminDataPack, "runtime", proto3);
_define_property(AdminDataPack, "typeName", "mono.authz.v1.AdminDataPack");
_define_property(AdminDataPack, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "fields",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListDataPacksRequest
 */ export class AdminListDataPacksRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListDataPacksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListDataPacksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListDataPacksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListDataPacksRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListDataPacksRequest, "runtime", proto3);
_define_property(AdminListDataPacksRequest, "typeName", "mono.authz.v1.AdminListDataPacksRequest");
_define_property(AdminListDataPacksRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.authz.v1.AdminListDataPacksResponse
 */ export class AdminListDataPacksResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListDataPacksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListDataPacksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListDataPacksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListDataPacksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminDataPack packs = 1;
   */ _define_property(this, "packs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListDataPacksResponse, "runtime", proto3);
_define_property(AdminListDataPacksResponse, "typeName", "mono.authz.v1.AdminListDataPacksResponse");
_define_property(AdminListDataPacksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "packs",
            kind: "message",
            T: AdminDataPack,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminUpdateScopeNodeRequest
 */ export class AdminUpdateScopeNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminUpdateScopeNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUpdateScopeNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUpdateScopeNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminUpdateScopeNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * empty = keep
   *
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * when true, parent_id applies ("" = tenant root)
   *
   * @generated from field: bool set_parent = 3;
   */ _define_property(this, "setParent", false), /**
   * @generated from field: string parent_id = 4;
   */ _define_property(this, "parentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminUpdateScopeNodeRequest, "runtime", proto3);
_define_property(AdminUpdateScopeNodeRequest, "typeName", "mono.authz.v1.AdminUpdateScopeNodeRequest");
_define_property(AdminUpdateScopeNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "set_parent",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminUpdateScopeNodeResponse
 */ export class AdminUpdateScopeNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminUpdateScopeNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUpdateScopeNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUpdateScopeNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminUpdateScopeNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminScopeNode node = 1;
   */ _define_property(this, "node", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminUpdateScopeNodeResponse, "runtime", proto3);
_define_property(AdminUpdateScopeNodeResponse, "typeName", "mono.authz.v1.AdminUpdateScopeNodeResponse");
_define_property(AdminUpdateScopeNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: AdminScopeNode
        }
    ]));
/**
 * Bundle CRUD (tenant-scoped rows only; see the service comment).
 * requires_break_glass_for is deliberately absent — break-glass wiring stays
 * ops-managed, not editable from the admin UI.
 *
 * @generated from message mono.authz.v1.AdminCreateBundleRequest
 */ export class AdminCreateBundleRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateBundleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateBundleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateBundleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateBundleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * full|simplified|masked|action_blocked
   *
   * @generated from field: string default_view_mode = 4;
   */ _define_property(this, "defaultViewMode", ""), /**
   * @generated from field: repeated string permitted_actions = 5;
   */ _define_property(this, "permittedActions", []), /**
   * Sensitive-data packs (K5) this role un-masks — keys from
   * AdminListDataPacks. Absent field 6 pre-round-7: the create path
   * silently dropped a template's packs.
   *
   * @generated from field: repeated string data_packs = 6;
   */ _define_property(this, "dataPacks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateBundleRequest, "runtime", proto3);
_define_property(AdminCreateBundleRequest, "typeName", "mono.authz.v1.AdminCreateBundleRequest");
_define_property(AdminCreateBundleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "default_view_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "permitted_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "data_packs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminCreateBundleResponse
 */ export class AdminCreateBundleResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateBundleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateBundleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateBundleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateBundleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminRoleBundle bundle = 1;
   */ _define_property(this, "bundle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateBundleResponse, "runtime", proto3);
_define_property(AdminCreateBundleResponse, "typeName", "mono.authz.v1.AdminCreateBundleResponse");
_define_property(AdminCreateBundleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bundle",
            kind: "message",
            T: AdminRoleBundle
        }
    ]));
/**
 * Full replace of the mutable fields; key identifies the tenant row and is
 * immutable. default_view_mode is required (an empty value would silently
 * broaden the bundle to full — same rule as the pangaea layer).
 *
 * @generated from message mono.authz.v1.AdminUpdateBundleRequest
 */ export class AdminUpdateBundleRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminUpdateBundleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUpdateBundleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUpdateBundleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminUpdateBundleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string default_view_mode = 4;
   */ _define_property(this, "defaultViewMode", ""), /**
   * @generated from field: repeated string permitted_actions = 5;
   */ _define_property(this, "permittedActions", []), /**
   * Packs replace the stored set only when replace_data_packs is true —
   * proto3 can't tell "clear" from "not sent", and a legacy caller that
   * omits packs must not silently strip a role's carve-outs.
   *
   * @generated from field: repeated string data_packs = 6;
   */ _define_property(this, "dataPacks", []), /**
   * @generated from field: bool replace_data_packs = 7;
   */ _define_property(this, "replaceDataPacks", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminUpdateBundleRequest, "runtime", proto3);
_define_property(AdminUpdateBundleRequest, "typeName", "mono.authz.v1.AdminUpdateBundleRequest");
_define_property(AdminUpdateBundleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "default_view_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "permitted_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "data_packs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "replace_data_packs",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminUpdateBundleResponse
 */ export class AdminUpdateBundleResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminUpdateBundleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUpdateBundleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUpdateBundleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminUpdateBundleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminRoleBundle bundle = 1;
   */ _define_property(this, "bundle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminUpdateBundleResponse, "runtime", proto3);
_define_property(AdminUpdateBundleResponse, "typeName", "mono.authz.v1.AdminUpdateBundleResponse");
_define_property(AdminUpdateBundleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bundle",
            kind: "message",
            T: AdminRoleBundle
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminDeleteBundleRequest
 */ export class AdminDeleteBundleRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminDeleteBundleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminDeleteBundleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminDeleteBundleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminDeleteBundleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminDeleteBundleRequest, "runtime", proto3);
_define_property(AdminDeleteBundleRequest, "typeName", "mono.authz.v1.AdminDeleteBundleRequest");
_define_property(AdminDeleteBundleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminDeleteBundleResponse
 */ export class AdminDeleteBundleResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminDeleteBundleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminDeleteBundleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminDeleteBundleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminDeleteBundleResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminDeleteBundleResponse, "runtime", proto3);
_define_property(AdminDeleteBundleResponse, "typeName", "mono.authz.v1.AdminDeleteBundleResponse");
_define_property(AdminDeleteBundleResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * AdminAssignment is a denormalised projection of (role_assignment +
 * the bundle's display name) so the admin UI's table can render
 * without a second round-trip.
 *
 * @generated from message mono.authz.v1.AdminAssignment
 */ export class AdminAssignment extends Message {
    static fromBinary(bytes, options) {
        return new AdminAssignment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAssignment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAssignment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminAssignment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Principal: exactly one of user_id / group_id is set.
   *
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string role_bundle_key = 3;
   */ _define_property(this, "roleBundleKey", ""), /**
   * @generated from field: string role_bundle_display_name = 4;
   */ _define_property(this, "roleBundleDisplayName", ""), /**
   * @generated from field: string scope_node_id = 5;
   */ _define_property(this, "scopeNodeId", ""), /**
   * @generated from field: string scope_display_name = 6;
   */ _define_property(this, "scopeDisplayName", ""), /**
   * primary|backup|designee|temporary|break_glass
   *
   * @generated from field: string assignment_type = 7;
   */ _define_property(this, "assignmentType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_start = 8;
   */ _define_property(this, "effectiveStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_end = 9;
   */ _define_property(this, "effectiveEnd", void 0), /**
   * @generated from field: string granted_by_user_id = 10;
   */ _define_property(this, "grantedByUserId", ""), /**
   * @generated from field: string reason = 11;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp revoked_at = 12;
   */ _define_property(this, "revokedAt", void 0), /**
   * @generated from field: string revoked_by_user_id = 13;
   */ _define_property(this, "revokedByUserId", ""), /**
   * @generated from field: string revoked_reason = 14;
   */ _define_property(this, "revokedReason", ""), /**
   * Group principal (see user_id). Empty for user grants.
   *
   * @generated from field: string group_id = 15;
   */ _define_property(this, "groupId", ""), /**
   * Designees only: the owner whose access this grant backs up. granted_by
   * is merely who created the row (often an admin acting for the owner).
   *
   * @generated from field: string original_owner_user_id = 16;
   */ _define_property(this, "originalOwnerUserId", ""), /**
   * Delegation lineage (doc 03): set only on a mirrored designee row.
   * delegation_id names the authz.delegation header it belongs to;
   * delegation_status mirrors that header's current status (badges the row
   * "active"/"revoked"/"expired" without a second round-trip per row — see
   * adminAssignmentFromPangaea / the list handlers' delegation join).
   *
   * @generated from field: string delegation_id = 17;
   */ _define_property(this, "delegationId", ""), /**
   * @generated from field: string delegation_status = 18;
   */ _define_property(this, "delegationStatus", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminAssignment, "runtime", proto3);
_define_property(AdminAssignment, "typeName", "mono.authz.v1.AdminAssignment");
_define_property(AdminAssignment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role_bundle_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "scope_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "assignment_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "effective_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "effective_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "granted_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "revoked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "revoked_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "revoked_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "original_owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "delegation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "delegation_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListAssignmentsForUserRequest
 */ export class AdminListAssignmentsForUserRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListAssignmentsForUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListAssignmentsForUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListAssignmentsForUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListAssignmentsForUserRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * include_inactive=true returns revoked + expired rows alongside
   * active ones (for the admin UI's history view).
   *
   * @generated from field: bool include_inactive = 2;
   */ _define_property(this, "includeInactive", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListAssignmentsForUserRequest, "runtime", proto3);
_define_property(AdminListAssignmentsForUserRequest, "typeName", "mono.authz.v1.AdminListAssignmentsForUserRequest");
_define_property(AdminListAssignmentsForUserRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_inactive",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListAssignmentsForUserResponse
 */ export class AdminListAssignmentsForUserResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListAssignmentsForUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListAssignmentsForUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListAssignmentsForUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListAssignmentsForUserResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminAssignment assignments = 1;
   */ _define_property(this, "assignments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListAssignmentsForUserResponse, "runtime", proto3);
_define_property(AdminListAssignmentsForUserResponse, "typeName", "mono.authz.v1.AdminListAssignmentsForUserResponse");
_define_property(AdminListAssignmentsForUserResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignments",
            kind: "message",
            T: AdminAssignment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminCreateRoleAssignmentRequest
 */ export class AdminCreateRoleAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateRoleAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateRoleAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateRoleAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateRoleAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Principal: exactly one of user_id / group_id must be set.
   *
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string role_bundle_key = 2;
   */ _define_property(this, "roleBundleKey", ""), /**
   * @generated from field: string scope_node_id = 3;
   */ _define_property(this, "scopeNodeId", ""), /**
   * primary|backup|designee|temporary|break_glass
   *
   * @generated from field: string assignment_type = 4;
   */ _define_property(this, "assignmentType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_start = 5;
   */ _define_property(this, "effectiveStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_end = 6;
   */ _define_property(this, "effectiveEnd", void 0), /**
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", ""), /**
   * designees only
   *
   * @generated from field: string original_owner_user_id = 8;
   */ _define_property(this, "originalOwnerUserId", ""), /**
   * group principal (polish task 04)
   *
   * @generated from field: string group_id = 9;
   */ _define_property(this, "groupId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateRoleAssignmentRequest, "runtime", proto3);
_define_property(AdminCreateRoleAssignmentRequest, "typeName", "mono.authz.v1.AdminCreateRoleAssignmentRequest");
_define_property(AdminCreateRoleAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "assignment_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "effective_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "original_owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminCreateRoleAssignmentResponse
 */ export class AdminCreateRoleAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateRoleAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateRoleAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateRoleAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateRoleAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminAssignment assignment = 1;
   */ _define_property(this, "assignment", void 0), /**
   * @generated from field: string role_grant_event_id = 2;
   */ _define_property(this, "roleGrantEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateRoleAssignmentResponse, "runtime", proto3);
_define_property(AdminCreateRoleAssignmentResponse, "typeName", "mono.authz.v1.AdminCreateRoleAssignmentResponse");
_define_property(AdminCreateRoleAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignment",
            kind: "message",
            T: AdminAssignment
        },
        {
            no: 2,
            name: "role_grant_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminRevokeRoleAssignmentRequest
 */ export class AdminRevokeRoleAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminRevokeRoleAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRevokeRoleAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRevokeRoleAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRevokeRoleAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRevokeRoleAssignmentRequest, "runtime", proto3);
_define_property(AdminRevokeRoleAssignmentRequest, "typeName", "mono.authz.v1.AdminRevokeRoleAssignmentRequest");
_define_property(AdminRevokeRoleAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminRevokeRoleAssignmentResponse
 */ export class AdminRevokeRoleAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminRevokeRoleAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRevokeRoleAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRevokeRoleAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRevokeRoleAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminAssignment assignment = 1;
   */ _define_property(this, "assignment", void 0), /**
   * @generated from field: string role_grant_event_id = 2;
   */ _define_property(this, "roleGrantEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRevokeRoleAssignmentResponse, "runtime", proto3);
_define_property(AdminRevokeRoleAssignmentResponse, "typeName", "mono.authz.v1.AdminRevokeRoleAssignmentResponse");
_define_property(AdminRevokeRoleAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignment",
            kind: "message",
            T: AdminAssignment
        },
        {
            no: 2,
            name: "role_grant_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * AdminRequestBreakGlass creates a time-bound break_glass assignment.
 * Default expiry 24h per Annex §6 — server caps at 24h regardless of
 * requested value. Resource owner is notified via the standard ops
 * audit + (future) notification service.
 *
 * @generated from message mono.authz.v1.AdminRequestBreakGlassRequest
 */ export class AdminRequestBreakGlassRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminRequestBreakGlassRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRequestBreakGlassRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRequestBreakGlassRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRequestBreakGlassRequest, a, b);
    }
    constructor(data){
        super(), /**
   * who needs the access (usually the caller)
   *
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string role_bundle_key = 2;
   */ _define_property(this, "roleBundleKey", ""), /**
   * @generated from field: string scope_node_id = 3;
   */ _define_property(this, "scopeNodeId", ""), /**
   * required, free text
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * duration_hours: clamped to [1, 24]. 0 → defaults to 24.
   *
   * @generated from field: int32 duration_hours = 5;
   */ _define_property(this, "durationHours", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRequestBreakGlassRequest, "runtime", proto3);
_define_property(AdminRequestBreakGlassRequest, "typeName", "mono.authz.v1.AdminRequestBreakGlassRequest");
_define_property(AdminRequestBreakGlassRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "duration_hours",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminRequestBreakGlassResponse
 */ export class AdminRequestBreakGlassResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminRequestBreakGlassResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRequestBreakGlassResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRequestBreakGlassResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRequestBreakGlassResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminAssignment assignment = 1;
   */ _define_property(this, "assignment", void 0), /**
   * @generated from field: string role_grant_event_id = 2;
   */ _define_property(this, "roleGrantEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRequestBreakGlassResponse, "runtime", proto3);
_define_property(AdminRequestBreakGlassResponse, "typeName", "mono.authz.v1.AdminRequestBreakGlassResponse");
_define_property(AdminRequestBreakGlassResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignment",
            kind: "message",
            T: AdminAssignment
        },
        {
            no: 2,
            name: "role_grant_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * AdminDelegation mirrors pangaea's Delegation header for the admin UI.
 * tenant_id / requested_by_user_id are implicit (JWT) — never on the wire,
 * same convention as AdminAssignment.
 *
 * @generated from message mono.authz.v1.AdminDelegation
 */ export class AdminDelegation extends Message {
    static fromBinary(bytes, options) {
        return new AdminDelegation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminDelegation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminDelegation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminDelegation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string owner_user_id = 2;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string delegate_user_id = 3;
   */ _define_property(this, "delegateUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp starts_at = 4;
   */ _define_property(this, "startsAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp ends_at = 5;
   */ _define_property(this, "endsAt", void 0), /**
   * manual | leave_derived
   *
   * @generated from field: string source = 6;
   */ _define_property(this, "source", ""), /**
   * requested|approved|active|expired|revoked|denied
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string reason = 8;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminDelegation, "runtime", proto3);
_define_property(AdminDelegation, "typeName", "mono.authz.v1.AdminDelegation");
_define_property(AdminDelegation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "delegate_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "starts_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "ends_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * AdminCreateDelegation — admin-only nomination (Decision 4). owner/delegate
 * must both already be platform users; a permission scoped to only some of
 * the owner's grants can be requested via role_bundle_key / scope_node_id
 * (empty = mirror every active grant the owner holds).
 *
 * @generated from message mono.authz.v1.AdminCreateDelegationRequest
 */ export class AdminCreateDelegationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateDelegationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateDelegationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateDelegationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateDelegationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string owner_user_id = 1;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string delegate_user_id = 2;
   */ _define_property(this, "delegateUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp starts_at = 3;
   */ _define_property(this, "startsAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp ends_at = 4;
   */ _define_property(this, "endsAt", void 0), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string role_bundle_key = 6;
   */ _define_property(this, "roleBundleKey", ""), /**
   * @generated from field: string scope_node_id = 7;
   */ _define_property(this, "scopeNodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateDelegationRequest, "runtime", proto3);
_define_property(AdminCreateDelegationRequest, "typeName", "mono.authz.v1.AdminCreateDelegationRequest");
_define_property(AdminCreateDelegationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "delegate_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "starts_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "ends_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminCreateDelegationResponse
 */ export class AdminCreateDelegationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateDelegationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateDelegationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateDelegationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateDelegationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminDelegation delegation = 1;
   */ _define_property(this, "delegation", void 0), /**
   * the mirrored rows
   *
   * @generated from field: repeated mono.authz.v1.AdminAssignment assignments = 2;
   */ _define_property(this, "assignments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateDelegationResponse, "runtime", proto3);
_define_property(AdminCreateDelegationResponse, "typeName", "mono.authz.v1.AdminCreateDelegationResponse");
_define_property(AdminCreateDelegationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "delegation",
            kind: "message",
            T: AdminDelegation
        },
        {
            no: 2,
            name: "assignments",
            kind: "message",
            T: AdminAssignment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListDelegationsRequest
 */ export class AdminListDelegationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListDelegationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListDelegationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListDelegationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListDelegationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string owner_user_id = 1;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string delegate_user_id = 2;
   */ _define_property(this, "delegateUserId", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: bool include_inactive = 4;
   */ _define_property(this, "includeInactive", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListDelegationsRequest, "runtime", proto3);
_define_property(AdminListDelegationsRequest, "typeName", "mono.authz.v1.AdminListDelegationsRequest");
_define_property(AdminListDelegationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "delegate_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_inactive",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListDelegationsResponse
 */ export class AdminListDelegationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListDelegationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListDelegationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListDelegationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListDelegationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminDelegation delegations = 1;
   */ _define_property(this, "delegations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListDelegationsResponse, "runtime", proto3);
_define_property(AdminListDelegationsResponse, "typeName", "mono.authz.v1.AdminListDelegationsResponse");
_define_property(AdminListDelegationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "delegations",
            kind: "message",
            T: AdminDelegation,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminRevokeDelegationRequest
 */ export class AdminRevokeDelegationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminRevokeDelegationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRevokeDelegationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRevokeDelegationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRevokeDelegationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRevokeDelegationRequest, "runtime", proto3);
_define_property(AdminRevokeDelegationRequest, "typeName", "mono.authz.v1.AdminRevokeDelegationRequest");
_define_property(AdminRevokeDelegationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminRevokeDelegationResponse
 */ export class AdminRevokeDelegationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminRevokeDelegationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRevokeDelegationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRevokeDelegationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRevokeDelegationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminDelegation delegation = 1;
   */ _define_property(this, "delegation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRevokeDelegationResponse, "runtime", proto3);
_define_property(AdminRevokeDelegationResponse, "typeName", "mono.authz.v1.AdminRevokeDelegationResponse");
_define_property(AdminRevokeDelegationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "delegation",
            kind: "message",
            T: AdminDelegation
        }
    ]));
/**
 * AdminScopeNode mirrors pangaea ScopeNode with the fields the admin UI
 * needs. tenant_id is implicit (from the JWT) so it is not on the wire.
 *
 * @generated from message mono.authz.v1.AdminScopeNode
 */ export class AdminScopeNode extends Message {
    static fromBinary(bytes, options) {
        return new AdminScopeNode().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminScopeNode().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminScopeNode().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminScopeNode, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * empty for the tenant root
   *
   * @generated from field: string parent_id = 2;
   */ _define_property(this, "parentId", ""), /**
   * tenant | division | portfolio | program | project | contract |
   * deliverable | artifact_class | financial_domain
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * e.g. "delivery.programs"
   *
   * @generated from field: string target_object_type = 4;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 5;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string display_name = 6;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: bool inherits_from_parent = 7;
   */ _define_property(this, "inheritsFromParent", false), /**
   * Phase 3c: standard | legal_privileged | source_selection_sensitive |
   * protective_order. Content under a legal-restricted node is NoView for
   * non-attorneys + AuditRequired.
   *
   * @generated from field: string sensitivity = 8;
   */ _define_property(this, "sensitivity", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminScopeNode, "runtime", proto3);
_define_property(AdminScopeNode, "typeName", "mono.authz.v1.AdminScopeNode");
_define_property(AdminScopeNode, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "inherits_from_parent",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "sensitivity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminCreateScopeNodeRequest
 */ export class AdminCreateScopeNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateScopeNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateScopeNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateScopeNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateScopeNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * empty = tenant root
   *
   * @generated from field: string parent_id = 1;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string target_object_type = 3;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 4;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string display_name = 5;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: bool inherits_from_parent = 6;
   */ _define_property(this, "inheritsFromParent", false), /**
   * Phase 3c; default "standard"
   *
   * @generated from field: string sensitivity = 7;
   */ _define_property(this, "sensitivity", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateScopeNodeRequest, "runtime", proto3);
_define_property(AdminCreateScopeNodeRequest, "typeName", "mono.authz.v1.AdminCreateScopeNodeRequest");
_define_property(AdminCreateScopeNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "inherits_from_parent",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "sensitivity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminCreateScopeNodeResponse
 */ export class AdminCreateScopeNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateScopeNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateScopeNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateScopeNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateScopeNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminScopeNode scope_node = 1;
   */ _define_property(this, "scopeNode", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateScopeNodeResponse, "runtime", proto3);
_define_property(AdminCreateScopeNodeResponse, "typeName", "mono.authz.v1.AdminCreateScopeNodeResponse");
_define_property(AdminCreateScopeNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_node",
            kind: "message",
            T: AdminScopeNode
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListScopeNodesRequest
 */ export class AdminListScopeNodesRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListScopeNodesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListScopeNodesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListScopeNodesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListScopeNodesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Case-insensitive substring matched against display_name and
   * target_object_id. Empty returns the newest nodes up to limit.
   *
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * 0 → server default (50).
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListScopeNodesRequest, "runtime", proto3);
_define_property(AdminListScopeNodesRequest, "typeName", "mono.authz.v1.AdminListScopeNodesRequest");
_define_property(AdminListScopeNodesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListScopeNodesResponse
 */ export class AdminListScopeNodesResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListScopeNodesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListScopeNodesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListScopeNodesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListScopeNodesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminScopeNode scope_nodes = 1;
   */ _define_property(this, "scopeNodes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListScopeNodesResponse, "runtime", proto3);
_define_property(AdminListScopeNodesResponse, "typeName", "mono.authz.v1.AdminListScopeNodesResponse");
_define_property(AdminListScopeNodesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_nodes",
            kind: "message",
            T: AdminScopeNode,
            repeated: true
        }
    ]));
/**
 * ScopeNodeSummary is the member-facing projection of a scope node (D12's
 * ListScopeNodes): the picker's minimum fields only. parent_id,
 * inherits_from_parent and sensitivity are admin-console-only and
 * deliberately absent from the wire type, not merely left unset.
 *
 * @generated from message mono.authz.v1.ScopeNodeSummary
 */ export class ScopeNodeSummary extends Message {
    static fromBinary(bytes, options) {
        return new ScopeNodeSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScopeNodeSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScopeNodeSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScopeNodeSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string target_object_type = 3;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 4;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string display_name = 5;
   */ _define_property(this, "displayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScopeNodeSummary, "runtime", proto3);
_define_property(ScopeNodeSummary, "typeName", "mono.authz.v1.ScopeNodeSummary");
_define_property(ScopeNodeSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListScopeNodesRequest
 */ export class ListScopeNodesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListScopeNodesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListScopeNodesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListScopeNodesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListScopeNodesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Case-insensitive substring matched against display_name and
   * target_object_id. Empty returns the newest nodes up to limit.
   *
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * 0 → server default (50).
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListScopeNodesRequest, "runtime", proto3);
_define_property(ListScopeNodesRequest, "typeName", "mono.authz.v1.ListScopeNodesRequest");
_define_property(ListScopeNodesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListScopeNodesResponse
 */ export class ListScopeNodesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListScopeNodesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListScopeNodesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListScopeNodesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListScopeNodesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.ScopeNodeSummary scope_nodes = 1;
   */ _define_property(this, "scopeNodes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListScopeNodesResponse, "runtime", proto3);
_define_property(ListScopeNodesResponse, "typeName", "mono.authz.v1.ListScopeNodesResponse");
_define_property(ListScopeNodesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_nodes",
            kind: "message",
            T: ScopeNodeSummary,
            repeated: true
        }
    ]));
/**
 * AdminGroup mirrors pangaea PrincipalGroup; tenant is implicit (JWT).
 *
 * @generated from message mono.authz.v1.AdminGroup
 */ export class AdminGroup extends Message {
    static fromBinary(bytes, options) {
        return new AdminGroup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminGroup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminGroup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminGroup, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string key = 2;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 3;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: int64 member_count = 5;
   */ _define_property(this, "memberCount", protoInt64.zero), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminGroup, "runtime", proto3);
_define_property(AdminGroup, "typeName", "mono.authz.v1.AdminGroup");
_define_property(AdminGroup, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "member_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminGroupMember
 */ export class AdminGroupMember extends Message {
    static fromBinary(bytes, options) {
        return new AdminGroupMember().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminGroupMember().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminGroupMember().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminGroupMember, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string group_id = 2;
   */ _define_property(this, "groupId", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string added_by_user_id = 4;
   */ _define_property(this, "addedByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminGroupMember, "runtime", proto3);
_define_property(AdminGroupMember, "typeName", "mono.authz.v1.AdminGroupMember");
_define_property(AdminGroupMember, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "added_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminCreateGroupRequest
 */ export class AdminCreateGroupRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateGroupRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateGroupRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateGroupRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateGroupRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateGroupRequest, "runtime", proto3);
_define_property(AdminCreateGroupRequest, "typeName", "mono.authz.v1.AdminCreateGroupRequest");
_define_property(AdminCreateGroupRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminCreateGroupResponse
 */ export class AdminCreateGroupResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminCreateGroupResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreateGroupResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreateGroupResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminCreateGroupResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminGroup group = 1;
   */ _define_property(this, "group", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminCreateGroupResponse, "runtime", proto3);
_define_property(AdminCreateGroupResponse, "typeName", "mono.authz.v1.AdminCreateGroupResponse");
_define_property(AdminCreateGroupResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "group",
            kind: "message",
            T: AdminGroup
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminUpdateGroupRequest
 */ export class AdminUpdateGroupRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminUpdateGroupRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUpdateGroupRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUpdateGroupRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminUpdateGroupRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminUpdateGroupRequest, "runtime", proto3);
_define_property(AdminUpdateGroupRequest, "typeName", "mono.authz.v1.AdminUpdateGroupRequest");
_define_property(AdminUpdateGroupRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminUpdateGroupResponse
 */ export class AdminUpdateGroupResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminUpdateGroupResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUpdateGroupResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUpdateGroupResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminUpdateGroupResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminGroup group = 1;
   */ _define_property(this, "group", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminUpdateGroupResponse, "runtime", proto3);
_define_property(AdminUpdateGroupResponse, "typeName", "mono.authz.v1.AdminUpdateGroupResponse");
_define_property(AdminUpdateGroupResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "group",
            kind: "message",
            T: AdminGroup
        }
    ]));
/**
 * Fails with FailedPrecondition while the group holds active assignments —
 * revoke them first so access removal stays explicit and audited.
 *
 * @generated from message mono.authz.v1.AdminDeleteGroupRequest
 */ export class AdminDeleteGroupRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminDeleteGroupRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminDeleteGroupRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminDeleteGroupRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminDeleteGroupRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminDeleteGroupRequest, "runtime", proto3);
_define_property(AdminDeleteGroupRequest, "typeName", "mono.authz.v1.AdminDeleteGroupRequest");
_define_property(AdminDeleteGroupRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminDeleteGroupResponse
 */ export class AdminDeleteGroupResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminDeleteGroupResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminDeleteGroupResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminDeleteGroupResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminDeleteGroupResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminDeleteGroupResponse, "runtime", proto3);
_define_property(AdminDeleteGroupResponse, "typeName", "mono.authz.v1.AdminDeleteGroupResponse");
_define_property(AdminDeleteGroupResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.authz.v1.AdminListGroupsRequest
 */ export class AdminListGroupsRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGroupsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGroupsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGroupsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGroupsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Case-insensitive substring matched against key and display_name.
   *
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * 0 → server default (50).
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGroupsRequest, "runtime", proto3);
_define_property(AdminListGroupsRequest, "typeName", "mono.authz.v1.AdminListGroupsRequest");
_define_property(AdminListGroupsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListGroupsResponse
 */ export class AdminListGroupsResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGroupsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGroupsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGroupsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGroupsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminGroup groups = 1;
   */ _define_property(this, "groups", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGroupsResponse, "runtime", proto3);
_define_property(AdminListGroupsResponse, "typeName", "mono.authz.v1.AdminListGroupsResponse");
_define_property(AdminListGroupsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "groups",
            kind: "message",
            T: AdminGroup,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminAddGroupMemberRequest
 */ export class AdminAddGroupMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminAddGroupMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAddGroupMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAddGroupMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminAddGroupMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string group_id = 1;
   */ _define_property(this, "groupId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminAddGroupMemberRequest, "runtime", proto3);
_define_property(AdminAddGroupMemberRequest, "typeName", "mono.authz.v1.AdminAddGroupMemberRequest");
_define_property(AdminAddGroupMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminAddGroupMemberResponse
 */ export class AdminAddGroupMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminAddGroupMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminAddGroupMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminAddGroupMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminAddGroupMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminGroupMember member = 1;
   */ _define_property(this, "member", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminAddGroupMemberResponse, "runtime", proto3);
_define_property(AdminAddGroupMemberResponse, "typeName", "mono.authz.v1.AdminAddGroupMemberResponse");
_define_property(AdminAddGroupMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "member",
            kind: "message",
            T: AdminGroupMember
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminRemoveGroupMemberRequest
 */ export class AdminRemoveGroupMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminRemoveGroupMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRemoveGroupMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRemoveGroupMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRemoveGroupMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string group_id = 1;
   */ _define_property(this, "groupId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRemoveGroupMemberRequest, "runtime", proto3);
_define_property(AdminRemoveGroupMemberRequest, "typeName", "mono.authz.v1.AdminRemoveGroupMemberRequest");
_define_property(AdminRemoveGroupMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminRemoveGroupMemberResponse
 */ export class AdminRemoveGroupMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminRemoveGroupMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRemoveGroupMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRemoveGroupMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRemoveGroupMemberResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRemoveGroupMemberResponse, "runtime", proto3);
_define_property(AdminRemoveGroupMemberResponse, "typeName", "mono.authz.v1.AdminRemoveGroupMemberResponse");
_define_property(AdminRemoveGroupMemberResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.authz.v1.AdminListGroupMembersRequest
 */ export class AdminListGroupMembersRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGroupMembersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGroupMembersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGroupMembersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGroupMembersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string group_id = 1;
   */ _define_property(this, "groupId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGroupMembersRequest, "runtime", proto3);
_define_property(AdminListGroupMembersRequest, "typeName", "mono.authz.v1.AdminListGroupMembersRequest");
_define_property(AdminListGroupMembersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListGroupMembersResponse
 */ export class AdminListGroupMembersResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGroupMembersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGroupMembersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGroupMembersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGroupMembersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminGroupMember members = 1;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGroupMembersResponse, "runtime", proto3);
_define_property(AdminListGroupMembersResponse, "typeName", "mono.authz.v1.AdminListGroupMembersResponse");
_define_property(AdminListGroupMembersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members",
            kind: "message",
            T: AdminGroupMember,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListGroupsForUserRequest
 */ export class AdminListGroupsForUserRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGroupsForUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGroupsForUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGroupsForUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGroupsForUserRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGroupsForUserRequest, "runtime", proto3);
_define_property(AdminListGroupsForUserRequest, "typeName", "mono.authz.v1.AdminListGroupsForUserRequest");
_define_property(AdminListGroupsForUserRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListGroupsForUserResponse
 */ export class AdminListGroupsForUserResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGroupsForUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGroupsForUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGroupsForUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGroupsForUserResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminGroup groups = 1;
   */ _define_property(this, "groups", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGroupsForUserResponse, "runtime", proto3);
_define_property(AdminListGroupsForUserResponse, "typeName", "mono.authz.v1.AdminListGroupsForUserResponse");
_define_property(AdminListGroupsForUserResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "groups",
            kind: "message",
            T: AdminGroup,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListAssignmentsForGroupRequest
 */ export class AdminListAssignmentsForGroupRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListAssignmentsForGroupRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListAssignmentsForGroupRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListAssignmentsForGroupRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListAssignmentsForGroupRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string group_id = 1;
   */ _define_property(this, "groupId", ""), /**
   * @generated from field: bool include_inactive = 2;
   */ _define_property(this, "includeInactive", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListAssignmentsForGroupRequest, "runtime", proto3);
_define_property(AdminListAssignmentsForGroupRequest, "typeName", "mono.authz.v1.AdminListAssignmentsForGroupRequest");
_define_property(AdminListAssignmentsForGroupRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_inactive",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListAssignmentsForGroupResponse
 */ export class AdminListAssignmentsForGroupResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListAssignmentsForGroupResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListAssignmentsForGroupResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListAssignmentsForGroupResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListAssignmentsForGroupResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminAssignment assignments = 1;
   */ _define_property(this, "assignments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListAssignmentsForGroupResponse, "runtime", proto3);
_define_property(AdminListAssignmentsForGroupResponse, "typeName", "mono.authz.v1.AdminListAssignmentsForGroupResponse");
_define_property(AdminListAssignmentsForGroupResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignments",
            kind: "message",
            T: AdminAssignment,
            repeated: true
        }
    ]));
/**
 * One append-only grant-ledger row. Exactly one of subject_user_id /
 * subject_group_id is set.
 *
 * @generated from message mono.authz.v1.AdminGrantEvent
 */ export class AdminGrantEvent extends Message {
    static fromBinary(bytes, options) {
        return new AdminGrantEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminGrantEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminGrantEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminGrantEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string role_assignment_id = 2;
   */ _define_property(this, "roleAssignmentId", ""), /**
   * granted | revoked | extended | break_glass_used | designee_granted | expired
   *
   * @generated from field: string event_kind = 3;
   */ _define_property(this, "eventKind", ""), /**
   * @generated from field: string actor_user_id = 4;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string subject_user_id = 5;
   */ _define_property(this, "subjectUserId", ""), /**
   * @generated from field: string subject_group_id = 6;
   */ _define_property(this, "subjectGroupId", ""), /**
   * @generated from field: string role_bundle_key = 7;
   */ _define_property(this, "roleBundleKey", ""), /**
   * @generated from field: string scope_node_id = 8;
   */ _define_property(this, "scopeNodeId", ""), /**
   * @generated from field: string assignment_type = 9;
   */ _define_property(this, "assignmentType", ""), /**
   * @generated from field: string reason = 10;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * actor granted TO THEMSELVES — the surface renders these loud.
   *
   * @generated from field: bool self_grant = 12;
   */ _define_property(this, "selfGrant", false), /**
   * Actor/subject display names, resolved server-side by ListAccessHistory
   * (SAD-208) so a non-admin grantor or access_audit:read capability holder
   * reading this ledger sees a person instead of a raw user id — the same
   * exposure ceiling as AccessRequestView's delegate names. Left unset by
   * AdminListGrantEvents (admin console callers already resolve names via
   * ResolveUserNames) and by anything unresolvable — deleted, deactivated,
   * nameless, or foreign tenant — for the client's raw-id fallback.
   *
   * @generated from field: string actor_display_name = 13;
   */ _define_property(this, "actorDisplayName", ""), /**
   * @generated from field: string subject_display_name = 14;
   */ _define_property(this, "subjectDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminGrantEvent, "runtime", proto3);
_define_property(AdminGrantEvent, "typeName", "mono.authz.v1.AdminGrantEvent");
_define_property(AdminGrantEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "subject_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "subject_group_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "assignment_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "self_grant",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "actor_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "subject_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListGrantEventsRequest
 */ export class AdminListGrantEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGrantEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGrantEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGrantEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGrantEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Newest-first page size; server clamps (default 50, max 200).
   *
   * @generated from field: int32 limit = 1;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGrantEventsRequest, "runtime", proto3);
_define_property(AdminListGrantEventsRequest, "typeName", "mono.authz.v1.AdminListGrantEventsRequest");
_define_property(AdminListGrantEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListGrantEventsResponse
 */ export class AdminListGrantEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGrantEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGrantEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGrantEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGrantEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminGrantEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGrantEventsResponse, "runtime", proto3);
_define_property(AdminListGrantEventsResponse, "typeName", "mono.authz.v1.AdminListGrantEventsResponse");
_define_property(AdminListGrantEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: AdminGrantEvent,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListAssignmentsForScopeNodeRequest
 */ export class AdminListAssignmentsForScopeNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListAssignmentsForScopeNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListAssignmentsForScopeNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListAssignmentsForScopeNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListAssignmentsForScopeNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string scope_node_id = 1;
   */ _define_property(this, "scopeNodeId", ""), /**
   * @generated from field: bool include_inactive = 2;
   */ _define_property(this, "includeInactive", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListAssignmentsForScopeNodeRequest, "runtime", proto3);
_define_property(AdminListAssignmentsForScopeNodeRequest, "typeName", "mono.authz.v1.AdminListAssignmentsForScopeNodeRequest");
_define_property(AdminListAssignmentsForScopeNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_inactive",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListAssignmentsForScopeNodeResponse
 */ export class AdminListAssignmentsForScopeNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListAssignmentsForScopeNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListAssignmentsForScopeNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListAssignmentsForScopeNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListAssignmentsForScopeNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminAssignment assignments = 1;
   */ _define_property(this, "assignments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListAssignmentsForScopeNodeResponse, "runtime", proto3);
_define_property(AdminListAssignmentsForScopeNodeResponse, "typeName", "mono.authz.v1.AdminListAssignmentsForScopeNodeResponse");
_define_property(AdminListAssignmentsForScopeNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignments",
            kind: "message",
            T: AdminAssignment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminGetScopeTreeRequest
 */ export class AdminGetScopeTreeRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminGetScopeTreeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminGetScopeTreeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminGetScopeTreeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminGetScopeTreeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * 0 = unlimited depth.
   *
   * @generated from field: int32 max_depth = 1;
   */ _define_property(this, "maxDepth", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminGetScopeTreeRequest, "runtime", proto3);
_define_property(AdminGetScopeTreeRequest, "typeName", "mono.authz.v1.AdminGetScopeTreeRequest");
_define_property(AdminGetScopeTreeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "max_depth",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminGetScopeTreeResponse
 */ export class AdminGetScopeTreeResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminGetScopeTreeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminGetScopeTreeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminGetScopeTreeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminGetScopeTreeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Flat, parent-linked (AdminScopeNode.parent_id; empty = the tenant root).
   *
   * @generated from field: repeated mono.authz.v1.AdminScopeNode nodes = 1;
   */ _define_property(this, "nodes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminGetScopeTreeResponse, "runtime", proto3);
_define_property(AdminGetScopeTreeResponse, "typeName", "mono.authz.v1.AdminGetScopeTreeResponse");
_define_property(AdminGetScopeTreeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "nodes",
            kind: "message",
            T: AdminScopeNode,
            repeated: true
        }
    ]));
/**
 * AdminRoleTemplate is one VERSION of a role-template family, projected for
 * the admin gallery. is_platform = seeded/ops-managed (immutable through this
 * surface); otherwise it's the caller-tenant's private template.
 *
 * @generated from message mono.authz.v1.AdminRoleTemplate
 */ export class AdminRoleTemplate extends Message {
    static fromBinary(bytes, options) {
        return new AdminRoleTemplate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminRoleTemplate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminRoleTemplate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminRoleTemplate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string family_id = 2;
   */ _define_property(this, "familyId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * @generated from field: bool is_platform = 4;
   */ _define_property(this, "isPlatform", false), /**
   * @generated from field: string key = 5;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 6;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 7;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string default_view_mode = 8;
   */ _define_property(this, "defaultViewMode", ""), /**
   * @generated from field: repeated string permitted_actions = 9;
   */ _define_property(this, "permittedActions", []), /**
   * @generated from field: repeated string data_packs = 10;
   */ _define_property(this, "dataPacks", []), /**
   * @generated from field: repeated string requires_break_glass_for = 11;
   */ _define_property(this, "requiresBreakGlassFor", []), /**
   * draft | published | archived
   *
   * @generated from field: string status = 12;
   */ _define_property(this, "status", ""), /**
   * Curated platform picks the gallery surfaces first (metadata.recommended).
   *
   * @generated from field: bool recommended = 13;
   */ _define_property(this, "recommended", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminRoleTemplate, "runtime", proto3);
_define_property(AdminRoleTemplate, "typeName", "mono.authz.v1.AdminRoleTemplate");
_define_property(AdminRoleTemplate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "family_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "is_platform",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "default_view_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "permitted_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "data_packs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "requires_break_glass_for",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "recommended",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListRoleTemplatesRequest
 */ export class AdminListRoleTemplatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListRoleTemplatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListRoleTemplatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListRoleTemplatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListRoleTemplatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty = all statuses; else draft|published|archived. Platform templates
   * plus the caller-tenant's private ones are always both included.
   *
   * @generated from field: string status = 1;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListRoleTemplatesRequest, "runtime", proto3);
_define_property(AdminListRoleTemplatesRequest, "typeName", "mono.authz.v1.AdminListRoleTemplatesRequest");
_define_property(AdminListRoleTemplatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListRoleTemplatesResponse
 */ export class AdminListRoleTemplatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListRoleTemplatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListRoleTemplatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListRoleTemplatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListRoleTemplatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminRoleTemplate templates = 1;
   */ _define_property(this, "templates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListRoleTemplatesResponse, "runtime", proto3);
_define_property(AdminListRoleTemplatesResponse, "typeName", "mono.authz.v1.AdminListRoleTemplatesResponse");
_define_property(AdminListRoleTemplatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "templates",
            kind: "message",
            T: AdminRoleTemplate,
            repeated: true
        }
    ]));
/**
 * AdminPinnedRole is a group template's role dependency resolved to the
 * human-facing shape (the pinned VERSION's key/name, not raw family ids) —
 * the "roles that will materialize" preview.
 *
 * @generated from message mono.authz.v1.AdminPinnedRole
 */ export class AdminPinnedRole extends Message {
    static fromBinary(bytes, options) {
        return new AdminPinnedRole().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminPinnedRole().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminPinnedRole().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminPinnedRole, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminPinnedRole, "runtime", proto3);
_define_property(AdminPinnedRole, "typeName", "mono.authz.v1.AdminPinnedRole");
_define_property(AdminPinnedRole, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminGroupTemplate
 */ export class AdminGroupTemplate extends Message {
    static fromBinary(bytes, options) {
        return new AdminGroupTemplate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminGroupTemplate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminGroupTemplate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminGroupTemplate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string family_id = 2;
   */ _define_property(this, "familyId", ""), /**
   * @generated from field: int32 version = 3;
   */ _define_property(this, "version", 0), /**
   * @generated from field: bool is_platform = 4;
   */ _define_property(this, "isPlatform", false), /**
   * @generated from field: string key = 5;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 6;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 7;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * @generated from field: repeated mono.authz.v1.AdminPinnedRole pinned_roles = 9;
   */ _define_property(this, "pinnedRoles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminGroupTemplate, "runtime", proto3);
_define_property(AdminGroupTemplate, "typeName", "mono.authz.v1.AdminGroupTemplate");
_define_property(AdminGroupTemplate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "family_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "is_platform",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "pinned_roles",
            kind: "message",
            T: AdminPinnedRole,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListGroupTemplatesRequest
 */ export class AdminListGroupTemplatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGroupTemplatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGroupTemplatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGroupTemplatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGroupTemplatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string status = 1;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGroupTemplatesRequest, "runtime", proto3);
_define_property(AdminListGroupTemplatesRequest, "typeName", "mono.authz.v1.AdminListGroupTemplatesRequest");
_define_property(AdminListGroupTemplatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListGroupTemplatesResponse
 */ export class AdminListGroupTemplatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListGroupTemplatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListGroupTemplatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListGroupTemplatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListGroupTemplatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminGroupTemplate templates = 1;
   */ _define_property(this, "templates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListGroupTemplatesResponse, "runtime", proto3);
_define_property(AdminListGroupTemplatesResponse, "typeName", "mono.authz.v1.AdminListGroupTemplatesResponse");
_define_property(AdminListGroupTemplatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "templates",
            kind: "message",
            T: AdminGroupTemplate,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminGetTemplateDiffRequest
 */ export class AdminGetTemplateDiffRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminGetTemplateDiffRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminGetTemplateDiffRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminGetTemplateDiffRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminGetTemplateDiffRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string family_id = 1;
   */ _define_property(this, "familyId", ""), /**
   * @generated from field: int32 from_version = 2;
   */ _define_property(this, "fromVersion", 0), /**
   * @generated from field: int32 to_version = 3;
   */ _define_property(this, "toVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminGetTemplateDiffRequest, "runtime", proto3);
_define_property(AdminGetTemplateDiffRequest, "typeName", "mono.authz.v1.AdminGetTemplateDiffRequest");
_define_property(AdminGetTemplateDiffRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "family_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "to_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminTemplateDiff
 */ export class AdminTemplateDiff extends Message {
    static fromBinary(bytes, options) {
        return new AdminTemplateDiff().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTemplateDiff().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTemplateDiff().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminTemplateDiff, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string added_actions = 1;
   */ _define_property(this, "addedActions", []), /**
   * @generated from field: repeated string removed_actions = 2;
   */ _define_property(this, "removedActions", []), /**
   * @generated from field: repeated string added_packs = 3;
   */ _define_property(this, "addedPacks", []), /**
   * @generated from field: repeated string removed_packs = 4;
   */ _define_property(this, "removedPacks", []), /**
   * @generated from field: string view_mode_from = 5;
   */ _define_property(this, "viewModeFrom", ""), /**
   * @generated from field: string view_mode_to = 6;
   */ _define_property(this, "viewModeTo", ""), /**
   * @generated from field: bool display_changed = 7;
   */ _define_property(this, "displayChanged", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminTemplateDiff, "runtime", proto3);
_define_property(AdminTemplateDiff, "typeName", "mono.authz.v1.AdminTemplateDiff");
_define_property(AdminTemplateDiff, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "added_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "removed_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "added_packs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "removed_packs",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "view_mode_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "view_mode_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "display_changed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminGetTemplateDiffResponse
 */ export class AdminGetTemplateDiffResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminGetTemplateDiffResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminGetTemplateDiffResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminGetTemplateDiffResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminGetTemplateDiffResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminTemplateDiff diff = 1;
   */ _define_property(this, "diff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminGetTemplateDiffResponse, "runtime", proto3);
_define_property(AdminGetTemplateDiffResponse, "typeName", "mono.authz.v1.AdminGetTemplateDiffResponse");
_define_property(AdminGetTemplateDiffResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "diff",
            kind: "message",
            T: AdminTemplateDiff
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminApplyRoleTemplateRequest
 */ export class AdminApplyRoleTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminApplyRoleTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminApplyRoleTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminApplyRoleTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminApplyRoleTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * A PUBLISHED version row (platform or the caller-tenant's own).
   *
   * @generated from field: string template_id = 1;
   */ _define_property(this, "templateId", ""), /**
   * Version upgrade: adopt this version over the existing instance (keeps
   * the instance id + display name; verbs/packs/view-mode/lineage snap).
   * Without it, an existing instance is returned untouched.
   *
   * @generated from field: bool overwrite_existing = 2;
   */ _define_property(this, "overwriteExisting", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminApplyRoleTemplateRequest, "runtime", proto3);
_define_property(AdminApplyRoleTemplateRequest, "typeName", "mono.authz.v1.AdminApplyRoleTemplateRequest");
_define_property(AdminApplyRoleTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "overwrite_existing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminApplyRoleTemplateResponse
 */ export class AdminApplyRoleTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminApplyRoleTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminApplyRoleTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminApplyRoleTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminApplyRoleTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminRoleBundle bundle = 1;
   */ _define_property(this, "bundle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminApplyRoleTemplateResponse, "runtime", proto3);
_define_property(AdminApplyRoleTemplateResponse, "typeName", "mono.authz.v1.AdminApplyRoleTemplateResponse");
_define_property(AdminApplyRoleTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bundle",
            kind: "message",
            T: AdminRoleBundle
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminApplyGroupTemplateRequest
 */ export class AdminApplyGroupTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminApplyGroupTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminApplyGroupTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminApplyGroupTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminApplyGroupTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string template_id = 1;
   */ _define_property(this, "templateId", ""), /**
   * REQUIRED — the apply never defaults to the tenant root.
   *
   * @generated from field: string scope_node_id = 2;
   */ _define_property(this, "scopeNodeId", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminApplyGroupTemplateRequest, "runtime", proto3);
_define_property(AdminApplyGroupTemplateRequest, "typeName", "mono.authz.v1.AdminApplyGroupTemplateRequest");
_define_property(AdminApplyGroupTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminApplyGroupTemplateResponse
 */ export class AdminApplyGroupTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminApplyGroupTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminApplyGroupTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminApplyGroupTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminApplyGroupTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminGroup group = 1;
   */ _define_property(this, "group", void 0), /**
   * The role instances the apply materialized (or found existing).
   *
   * @generated from field: repeated mono.authz.v1.AdminRoleBundle bundles = 2;
   */ _define_property(this, "bundles", []), /**
   * The group-targeted scoped grants it created.
   *
   * @generated from field: repeated mono.authz.v1.AdminAssignment assignments = 3;
   */ _define_property(this, "assignments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminApplyGroupTemplateResponse, "runtime", proto3);
_define_property(AdminApplyGroupTemplateResponse, "typeName", "mono.authz.v1.AdminApplyGroupTemplateResponse");
_define_property(AdminApplyGroupTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "group",
            kind: "message",
            T: AdminGroup
        },
        {
            no: 2,
            name: "bundles",
            kind: "message",
            T: AdminRoleBundle,
            repeated: true
        },
        {
            no: 3,
            name: "assignments",
            kind: "message",
            T: AdminAssignment,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminSaveAsTemplateRequest
 */ export class AdminSaveAsTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminSaveAsTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminSaveAsTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminSaveAsTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminSaveAsTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Key of a tenant-owned role instance (built-ins can't be snapshotted —
   * they already have a platform template).
   *
   * @generated from field: string bundle_key = 1;
   */ _define_property(this, "bundleKey", ""), /**
   * Optional overrides; empty = taken from the instance.
   *
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminSaveAsTemplateRequest, "runtime", proto3);
_define_property(AdminSaveAsTemplateRequest, "typeName", "mono.authz.v1.AdminSaveAsTemplateRequest");
_define_property(AdminSaveAsTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminSaveAsTemplateResponse
 */ export class AdminSaveAsTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminSaveAsTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminSaveAsTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminSaveAsTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminSaveAsTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminRoleTemplate template = 1;
   */ _define_property(this, "template", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminSaveAsTemplateResponse, "runtime", proto3);
_define_property(AdminSaveAsTemplateResponse, "typeName", "mono.authz.v1.AdminSaveAsTemplateResponse");
_define_property(AdminSaveAsTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template",
            kind: "message",
            T: AdminRoleTemplate
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminPublishTemplateRequest
 */ export class AdminPublishTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminPublishTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminPublishTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminPublishTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminPublishTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string template_id = 1;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminPublishTemplateRequest, "runtime", proto3);
_define_property(AdminPublishTemplateRequest, "typeName", "mono.authz.v1.AdminPublishTemplateRequest");
_define_property(AdminPublishTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminPublishTemplateResponse
 */ export class AdminPublishTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminPublishTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminPublishTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminPublishTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminPublishTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminRoleTemplate template = 1;
   */ _define_property(this, "template", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminPublishTemplateResponse, "runtime", proto3);
_define_property(AdminPublishTemplateResponse, "typeName", "mono.authz.v1.AdminPublishTemplateResponse");
_define_property(AdminPublishTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template",
            kind: "message",
            T: AdminRoleTemplate
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminArchiveTemplateRequest
 */ export class AdminArchiveTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminArchiveTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminArchiveTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminArchiveTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminArchiveTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string template_id = 1;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminArchiveTemplateRequest, "runtime", proto3);
_define_property(AdminArchiveTemplateRequest, "typeName", "mono.authz.v1.AdminArchiveTemplateRequest");
_define_property(AdminArchiveTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminArchiveTemplateResponse
 */ export class AdminArchiveTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminArchiveTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminArchiveTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminArchiveTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminArchiveTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminRoleTemplate template = 1;
   */ _define_property(this, "template", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminArchiveTemplateResponse, "runtime", proto3);
_define_property(AdminArchiveTemplateResponse, "typeName", "mono.authz.v1.AdminArchiveTemplateResponse");
_define_property(AdminArchiveTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template",
            kind: "message",
            T: AdminRoleTemplate
        }
    ]));
/**
 * AccessRequestView is the member/reviewer projection of one request.
 * Deliberately NO decided_by field — a requester never learns reviewer
 * identities (reviewers have the grant ledger for that).
 *
 * @generated from message mono.authz.v1.AccessRequestView
 */ export class AccessRequestView extends Message {
    static fromBinary(bytes, options) {
        return new AccessRequestView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AccessRequestView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AccessRequestView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AccessRequestView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string requester_user_id = 2;
   */ _define_property(this, "requesterUserId", ""), /**
   * @generated from field: string target_object_type = 3;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 4;
   */ _define_property(this, "targetObjectId", ""), /**
   * view | contribute | delegation
   *
   * @generated from field: string intent = 5;
   */ _define_property(this, "intent", ""), /**
   * @generated from field: string message = 6;
   */ _define_property(this, "message", ""), /**
   * pending|approved|denied|cancelled|superseded
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string decision_reason = 8;
   */ _define_property(this, "decisionReason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 10;
   */ _define_property(this, "decidedAt", void 0), /**
   * Set on approve — the grant the requester received.
   *
   * @generated from field: string role_assignment_id = 11;
   */ _define_property(this, "roleAssignmentId", ""), /**
   * Delegation-lane fields (intent='delegation' only) — see the D12 header
   * comment on RequestAccessRequest for the naming rationale.
   *
   * @generated from field: string original_owner_user_id = 12;
   */ _define_property(this, "originalOwnerUserId", ""), /**
   * @generated from field: string delegate_user_id = 13;
   */ _define_property(this, "delegateUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_start = 14;
   */ _define_property(this, "effectiveStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_end = 15;
   */ _define_property(this, "effectiveEnd", void 0), /**
   * Set on approve — the authz.delegation header minted for this request.
   *
   * @generated from field: string delegation_id = 16;
   */ _define_property(this, "delegationId", ""), /**
   * Delegate's display name, resolved server-side by ListAccessRequests
   * (SAD-208) so the member's own request list can show a person instead of
   * a raw user id. Same exposure ceiling as TenantMemberSummary: the display
   * name of an active tenant member, nothing else — and only on rows the
   * caller may already list. Empty when the delegate no longer resolves in
   * the caller's tenant (departed/deactivated/nameless); clients fall back
   * to delegate_user_id, never a blank.
   *
   * @generated from field: string delegate_display_name = 17;
   */ _define_property(this, "delegateDisplayName", ""), /**
   * Requester's and original owner's display names (SAD-208), resolved the
   * same server-side way and to the same exposure ceiling as
   * delegate_display_name — including for REVIEWER callers: a non-admin
   * access_grantors reviewer can Decide but has no route to the admin-only
   * name resolver, so the review surfaces (ReviewAccessRequestDialog,
   * ActivityPage) must read names from here instead. Empty when
   * unresolvable; clients fall back to requester_user_id /
   * original_owner_user_id, never a blank.
   *
   * @generated from field: string requester_display_name = 18;
   */ _define_property(this, "requesterDisplayName", ""), /**
   * @generated from field: string original_owner_display_name = 19;
   */ _define_property(this, "originalOwnerDisplayName", ""), /**
   * The target's scope-node display name (SAD-208 round 2): the review
   * dialog, reviewer queue and self-service panel rendered the raw
   * target_object_id (a program UUID) next to the freshly-named people.
   * Resolved server-side from the owning scope node — one display name,
   * nothing else — and ONLY by the two read lanes surfaces render from,
   * ListAccessRequests and GetAccessRequest; mutation responses
   * (RequestAccess/Cancel/Decide) leave it empty because their clients
   * refetch. Entitlement ceiling: reviewers get it on every row (they read
   * tenant-wide scope names via ListScopeNodes already); a non-reviewer gets
   * it only on delegation rows, whose target the owner covers by
   * construction — a view/contribute filing is a request for something the
   * caller cannot see, and this field must not name it for them. Also empty
   * when no node owns the target or it has no name. Clients fall back to
   * target_object_id, never a blank.
   *
   * @generated from field: string target_display_name = 20;
   */ _define_property(this, "targetDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AccessRequestView, "runtime", proto3);
_define_property(AccessRequestView, "typeName", "mono.authz.v1.AccessRequestView");
_define_property(AccessRequestView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "requester_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "intent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "decision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "role_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "original_owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "delegate_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "effective_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "effective_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "delegation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "delegate_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "requester_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "original_owner_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "target_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.RequestAccessRequest
 */ export class RequestAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new RequestAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * e.g. "delivery.programs"
   *
   * @generated from field: string target_object_type = 1;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 2;
   */ _define_property(this, "targetObjectId", ""), /**
   * view (default) | contribute | delegation
   *
   * @generated from field: string intent = 3;
   */ _define_property(this, "intent", ""), /**
   * @generated from field: string message = 4;
   */ _define_property(this, "message", ""), /**
   * Client-supplied replay key; duplicate submits converge on one request.
   *
   * @generated from field: string idempotency_key = 5;
   */ _define_property(this, "idempotencyKey", ""), /**
   * Delegation-lane fields (intent='delegation' only, D12: delegation rides
   * this lane rather than a new header table). requester (from context) is
   * whoever FILED — the owner, on this self-service surface;
   * original_owner_user_id names the owner whose access is delegated and
   * delegate_user_id names the nominee — mirroring authz.delegation's
   * (owner_user_id, delegate_user_id) shape. The window is REQUIRED —
   * delegation is always time-boxed.
   *
   * @generated from field: string original_owner_user_id = 6;
   */ _define_property(this, "originalOwnerUserId", ""), /**
   * @generated from field: string delegate_user_id = 7;
   */ _define_property(this, "delegateUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_start = 8;
   */ _define_property(this, "effectiveStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_end = 9;
   */ _define_property(this, "effectiveEnd", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestAccessRequest, "runtime", proto3);
_define_property(RequestAccessRequest, "typeName", "mono.authz.v1.RequestAccessRequest");
_define_property(RequestAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "intent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "idempotency_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "original_owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "delegate_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "effective_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "effective_end",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.authz.v1.RequestAccessResponse
 */ export class RequestAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new RequestAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestAccessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AccessRequestView request = 1;
   */ _define_property(this, "request", void 0), /**
   * False when this call converged on an existing pending request instead of
   * filing a new one (D12: repository dedupes identical
   * owner/delegate/scope). Lets the caller distinguish a fresh filing from a
   * replay instead of reporting success for both. `optional` for explicit
   * field presence: a response from a replica that predates this field
   * decodes with created ABSENT, not false - callers must treat absence as
   * the legacy fresh-success behaviour and reserve the already-pending path
   * for an explicit false, or a mixed-version rollout reports a genuinely
   * new request as an already-pending replay.
   *
   * @generated from field: optional bool created = 2;
   */ _define_property(this, "created", void 0), /**
   * Set only for a delegation filing that converged past a PRIOR DENIAL of
   * the IDENTICAL window (000114) -- the decided_at of that denied request,
   * so the self-service dialog can show an inline informational notice ("an
   * identical request was denied on <date>"). Informational only: it is
   * never set alongside a block (an identical window against a still-live
   * or scheduled APPROVAL is refused as a Connect error instead, not a
   * successful response with a notice) and never set for a fresh or
   * different-window filing. `optional` for the same explicit-presence
   * reason as `created` above: a response from a replica predating this
   * field must decode with prior_denial_at ABSENT, and absence must read as
   * "no notice" -- never as a false "nothing was ever denied" during a
   * mixed-version rollout.
   *
   * @generated from field: optional google.protobuf.Timestamp prior_denial_at = 3;
   */ _define_property(this, "priorDenialAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestAccessResponse, "runtime", proto3);
_define_property(RequestAccessResponse, "typeName", "mono.authz.v1.RequestAccessResponse");
_define_property(RequestAccessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "request",
            kind: "message",
            T: AccessRequestView
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 3,
            name: "prior_denial_at",
            kind: "message",
            T: Timestamp,
            opt: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.CancelAccessRequestRequest
 */ export class CancelAccessRequestRequest extends Message {
    static fromBinary(bytes, options) {
        return new CancelAccessRequestRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelAccessRequestRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelAccessRequestRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelAccessRequestRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelAccessRequestRequest, "runtime", proto3);
_define_property(CancelAccessRequestRequest, "typeName", "mono.authz.v1.CancelAccessRequestRequest");
_define_property(CancelAccessRequestRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.CancelAccessRequestResponse
 */ export class CancelAccessRequestResponse extends Message {
    static fromBinary(bytes, options) {
        return new CancelAccessRequestResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CancelAccessRequestResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CancelAccessRequestResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CancelAccessRequestResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AccessRequestView request = 1;
   */ _define_property(this, "request", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CancelAccessRequestResponse, "runtime", proto3);
_define_property(CancelAccessRequestResponse, "typeName", "mono.authz.v1.CancelAccessRequestResponse");
_define_property(CancelAccessRequestResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "request",
            kind: "message",
            T: AccessRequestView
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListAccessRequestsRequest
 */ export class ListAccessRequestsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAccessRequestsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAccessRequestsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAccessRequestsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAccessRequestsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * empty = all
   *
   * @generated from field: string status = 1;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAccessRequestsRequest, "runtime", proto3);
_define_property(ListAccessRequestsRequest, "typeName", "mono.authz.v1.ListAccessRequestsRequest");
_define_property(ListAccessRequestsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListAccessRequestsResponse
 */ export class ListAccessRequestsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAccessRequestsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAccessRequestsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAccessRequestsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAccessRequestsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AccessRequestView requests = 1;
   */ _define_property(this, "requests", []), /**
   * True when the caller passed the reviewer gate (list is tenant-wide);
   * false = the list holds only the caller's own requests.
   *
   * @generated from field: bool reviewer = 2;
   */ _define_property(this, "reviewer", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAccessRequestsResponse, "runtime", proto3);
_define_property(ListAccessRequestsResponse, "typeName", "mono.authz.v1.ListAccessRequestsResponse");
_define_property(ListAccessRequestsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "requests",
            kind: "message",
            T: AccessRequestView,
            repeated: true
        },
        {
            no: 2,
            name: "reviewer",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListGrantableRolesRequest
 */ export class ListGrantableRolesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGrantableRolesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrantableRolesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrantableRolesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrantableRolesRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrantableRolesRequest, "runtime", proto3);
_define_property(ListGrantableRolesRequest, "typeName", "mono.authz.v1.ListGrantableRolesRequest");
_define_property(ListGrantableRolesRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.authz.v1.GrantableRole
 */ export class GrantableRole extends Message {
    static fromBinary(bytes, options) {
        return new GrantableRole().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrantableRole().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrantableRole().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrantableRole, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string default_view_mode = 4;
   */ _define_property(this, "defaultViewMode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrantableRole, "runtime", proto3);
_define_property(GrantableRole, "typeName", "mono.authz.v1.GrantableRole");
_define_property(GrantableRole, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "default_view_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListGrantableRolesResponse
 */ export class ListGrantableRolesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGrantableRolesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrantableRolesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrantableRolesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrantableRolesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.GrantableRole roles = 1;
   */ _define_property(this, "roles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrantableRolesResponse, "runtime", proto3);
_define_property(ListGrantableRolesResponse, "typeName", "mono.authz.v1.ListGrantableRolesResponse");
_define_property(ListGrantableRolesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "roles",
            kind: "message",
            T: GrantableRole,
            repeated: true
        }
    ]));
/**
 * TenantMemberSummary is the member-facing projection of a pangaea User for
 * the delegate picker (SAD-112 item b). Deliberately id + display_name only:
 * this is a dedicated message, not a slice of the admin-shaped User, so
 * email/role/tenant_id/active are structurally impossible to leak here, not
 * merely left unset.
 *
 * @generated from message mono.authz.v1.TenantMemberSummary
 */ export class TenantMemberSummary extends Message {
    static fromBinary(bytes, options) {
        return new TenantMemberSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TenantMemberSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TenantMemberSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TenantMemberSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TenantMemberSummary, "runtime", proto3);
_define_property(TenantMemberSummary, "typeName", "mono.authz.v1.TenantMemberSummary");
_define_property(TenantMemberSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.SearchTenantMembersRequest
 */ export class SearchTenantMembersRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchTenantMembersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchTenantMembersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchTenantMembersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchTenantMembersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Matched ONLY against display_name server-side, case-insensitive
   * substring — never email, even though pangaea's underlying ListUsers
   * matches name OR email. Below a 2-character minimum, the handler returns
   * an empty result (not an error) so the picker can render "type to search"
   * without an error state.
   *
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * 0 → server default. Capped at 20 regardless of what's requested — this
   * is a typeahead, not a directory dump.
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchTenantMembersRequest, "runtime", proto3);
_define_property(SearchTenantMembersRequest, "typeName", "mono.authz.v1.SearchTenantMembersRequest");
_define_property(SearchTenantMembersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.SearchTenantMembersResponse
 */ export class SearchTenantMembersResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchTenantMembersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchTenantMembersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchTenantMembersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchTenantMembersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.TenantMemberSummary members = 1;
   */ _define_property(this, "members", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchTenantMembersResponse, "runtime", proto3);
_define_property(SearchTenantMembersResponse, "typeName", "mono.authz.v1.SearchTenantMembersResponse");
_define_property(SearchTenantMembersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "members",
            kind: "message",
            T: TenantMemberSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.GetAccessRequestRequest
 */ export class GetAccessRequestRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAccessRequestRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAccessRequestRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAccessRequestRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAccessRequestRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAccessRequestRequest, "runtime", proto3);
_define_property(GetAccessRequestRequest, "typeName", "mono.authz.v1.GetAccessRequestRequest");
_define_property(GetAccessRequestRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.GetAccessRequestResponse
 */ export class GetAccessRequestResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAccessRequestResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAccessRequestResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAccessRequestResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAccessRequestResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AccessRequestView request = 1;
   */ _define_property(this, "request", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAccessRequestResponse, "runtime", proto3);
_define_property(GetAccessRequestResponse, "typeName", "mono.authz.v1.GetAccessRequestResponse");
_define_property(GetAccessRequestResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "request",
            kind: "message",
            T: AccessRequestView
        }
    ]));
/**
 * @generated from message mono.authz.v1.DecideAccessRequestRequest
 */ export class DecideAccessRequestRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideAccessRequestRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideAccessRequestRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideAccessRequestRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideAccessRequestRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool approve = 2;
   */ _define_property(this, "approve", false), /**
   * Required on approve: the ACTIVE role (tenant instance, by key — the same
   * vocabulary the grant dialog uses) the requester receives.
   *
   * @generated from field: string role_bundle_key = 3;
   */ _define_property(this, "roleBundleKey", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideAccessRequestRequest, "runtime", proto3);
_define_property(DecideAccessRequestRequest, "typeName", "mono.authz.v1.DecideAccessRequestRequest");
_define_property(DecideAccessRequestRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "approve",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.DecideAccessRequestResponse
 */ export class DecideAccessRequestResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideAccessRequestResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideAccessRequestResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideAccessRequestResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideAccessRequestResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AccessRequestView request = 1;
   */ _define_property(this, "request", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideAccessRequestResponse, "runtime", proto3);
_define_property(DecideAccessRequestResponse, "typeName", "mono.authz.v1.DecideAccessRequestResponse");
_define_property(DecideAccessRequestResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "request",
            kind: "message",
            T: AccessRequestView
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminExtendDesigneeRequest
 */ export class AdminExtendDesigneeRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminExtendDesigneeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminExtendDesigneeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminExtendDesigneeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminExtendDesigneeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: google.protobuf.Timestamp new_effective_end = 2;
   */ _define_property(this, "newEffectiveEnd", void 0), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminExtendDesigneeRequest, "runtime", proto3);
_define_property(AdminExtendDesigneeRequest, "typeName", "mono.authz.v1.AdminExtendDesigneeRequest");
_define_property(AdminExtendDesigneeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "new_effective_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminExtendDesigneeResponse
 */ export class AdminExtendDesigneeResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminExtendDesigneeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminExtendDesigneeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminExtendDesigneeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminExtendDesigneeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AdminAssignment assignment = 1;
   */ _define_property(this, "assignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminExtendDesigneeResponse, "runtime", proto3);
_define_property(AdminExtendDesigneeResponse, "typeName", "mono.authz.v1.AdminExtendDesigneeResponse");
_define_property(AdminExtendDesigneeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignment",
            kind: "message",
            T: AdminAssignment
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListAccessHistoryRequest
 */ export class ListAccessHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAccessHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAccessHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAccessHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAccessHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty = all subjects; else only events/requests about this user.
   *
   * @generated from field: string subject_user_id = 1;
   */ _define_property(this, "subjectUserId", ""), /**
   * Deprecated: use pagination.page_size. Ignored once pagination is set.
   *
   * default 50
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * Filters below apply to `events` only (requests keep the subject-only
   * shape they've always had — the panel doesn't render them). Every filter
   * is optional; unset means no constraint on that dimension.
   *
   * @generated from field: string actor_user_id = 3;
   */ _define_property(this, "actorUserId", ""), /**
   * Must be members of the ledger's kind vocabulary (see AdminGrantEvent.event_kind).
   *
   * @generated from field: repeated string event_kinds = 4;
   */ _define_property(this, "eventKinds", []), /**
   * @generated from field: google.protobuf.Timestamp created_after = 5;
   */ _define_property(this, "createdAfter", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_before = 6;
   */ _define_property(this, "createdBefore", void 0), /**
   * @generated from field: mono.common.v1.PaginationRequest pagination = 7;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAccessHistoryRequest, "runtime", proto3);
_define_property(ListAccessHistoryRequest, "typeName", "mono.authz.v1.ListAccessHistoryRequest");
_define_property(ListAccessHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "subject_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "event_kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "created_after",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "created_before",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "pagination",
            kind: "message",
            T: PaginationRequest
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListAccessHistoryResponse
 */ export class ListAccessHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAccessHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAccessHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAccessHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAccessHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AdminGrantEvent events = 1;
   */ _define_property(this, "events", []), /**
   * @generated from field: repeated mono.authz.v1.AccessRequestView requests = 2;
   */ _define_property(this, "requests", []), /**
   * Pagination state for `events`.
   *
   * @generated from field: mono.common.v1.PaginationResponse pagination = 3;
   */ _define_property(this, "pagination", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAccessHistoryResponse, "runtime", proto3);
_define_property(ListAccessHistoryResponse, "typeName", "mono.authz.v1.ListAccessHistoryResponse");
_define_property(ListAccessHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: AdminGrantEvent,
            repeated: true
        },
        {
            no: 2,
            name: "requests",
            kind: "message",
            T: AccessRequestView,
            repeated: true
        },
        {
            no: 3,
            name: "pagination",
            kind: "message",
            T: PaginationResponse
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListAudienceGroupsRequest
 */ export class ListAudienceGroupsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAudienceGroupsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAudienceGroupsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAudienceGroupsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAudienceGroupsRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAudienceGroupsRequest, "runtime", proto3);
_define_property(ListAudienceGroupsRequest, "typeName", "mono.authz.v1.ListAudienceGroupsRequest");
_define_property(ListAudienceGroupsRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.authz.v1.AudienceGroupSummary
 */ export class AudienceGroupSummary extends Message {
    static fromBinary(bytes, options) {
        return new AudienceGroupSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AudienceGroupSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AudienceGroupSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AudienceGroupSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AudienceGroupSummary, "runtime", proto3);
_define_property(AudienceGroupSummary, "typeName", "mono.authz.v1.AudienceGroupSummary");
_define_property(AudienceGroupSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.ListAudienceGroupsResponse
 */ export class ListAudienceGroupsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAudienceGroupsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAudienceGroupsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAudienceGroupsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAudienceGroupsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AudienceGroupSummary groups = 1;
   */ _define_property(this, "groups", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAudienceGroupsResponse, "runtime", proto3);
_define_property(ListAudienceGroupsResponse, "typeName", "mono.authz.v1.ListAudienceGroupsResponse");
_define_property(ListAudienceGroupsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "groups",
            kind: "message",
            T: AudienceGroupSummary,
            repeated: true
        }
    ]));
/**
 * AccessRuleView is one catalogue rule with the tenant's effective value.
 *
 * @generated from message mono.authz.v1.AccessRuleView
 */ export class AccessRuleView extends Message {
    static fromBinary(bytes, options) {
        return new AccessRuleView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AccessRuleView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AccessRuleView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AccessRuleView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string question = 2;
   */ _define_property(this, "question", ""), /**
   * @generated from field: string mode = 3;
   */ _define_property(this, "mode", ""), /**
   * @generated from field: repeated string actions = 4;
   */ _define_property(this, "actions", []), /**
   * @generated from field: string default_mode = 5;
   */ _define_property(this, "defaultMode", ""), /**
   * @generated from field: repeated string default_actions = 6;
   */ _define_property(this, "defaultActions", []), /**
   * @generated from field: repeated string allowed_modes = 7;
   */ _define_property(this, "allowedModes", []), /**
   * True when the tenant changed the rule (a stored setting exists).
   *
   * @generated from field: bool customised = 8;
   */ _define_property(this, "customised", false), /**
   * @generated from field: string updated_by = 9;
   */ _define_property(this, "updatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string od = 11;
   */ _define_property(this, "od", ""), /**
   * @generated from field: repeated string roles = 12;
   */ _define_property(this, "roles", []), /**
   * @generated from field: repeated string default_roles = 13;
   */ _define_property(this, "defaultRoles", []), /**
   * Read-only labels of the rule's hard denies (e.g. "No self-grant").
   *
   * @generated from field: repeated string hard_denies = 14;
   */ _define_property(this, "hardDenies", []), /**
   * The rule is a ceiling for per-record audiences (hearsay.read).
   *
   * @generated from field: bool record_audience = 15;
   */ _define_property(this, "recordAudience", false), /**
   * Display name of updated_by, when resolvable.
   *
   * @generated from field: string updated_by_name = 16;
   */ _define_property(this, "updatedByName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AccessRuleView, "runtime", proto3);
_define_property(AccessRuleView, "typeName", "mono.authz.v1.AccessRuleView");
_define_property(AccessRuleView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "default_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "default_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "allowed_modes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "customised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "od",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "default_roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 14,
            name: "hard_denies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 15,
            name: "record_audience",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "updated_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminListAccessRulesRequest
 */ export class AdminListAccessRulesRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminListAccessRulesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListAccessRulesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListAccessRulesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListAccessRulesRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListAccessRulesRequest, "runtime", proto3);
_define_property(AdminListAccessRulesRequest, "typeName", "mono.authz.v1.AdminListAccessRulesRequest");
_define_property(AdminListAccessRulesRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.authz.v1.AdminListAccessRulesResponse
 */ export class AdminListAccessRulesResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminListAccessRulesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminListAccessRulesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminListAccessRulesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminListAccessRulesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.authz.v1.AccessRuleView rules = 1;
   */ _define_property(this, "rules", []), /**
   * The canonical actions a rule may name (the server accepts exactly these).
   *
   * @generated from field: repeated string available_actions = 2;
   */ _define_property(this, "availableActions", []), /**
   * The platform user roles a rule may be limited to.
   *
   * @generated from field: repeated string available_roles = 3;
   */ _define_property(this, "availableRoles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminListAccessRulesResponse, "runtime", proto3);
_define_property(AdminListAccessRulesResponse, "typeName", "mono.authz.v1.AdminListAccessRulesResponse");
_define_property(AdminListAccessRulesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rules",
            kind: "message",
            T: AccessRuleView,
            repeated: true
        },
        {
            no: 2,
            name: "available_actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "available_roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminUpdateAccessRuleRequest
 */ export class AdminUpdateAccessRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminUpdateAccessRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUpdateAccessRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUpdateAccessRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminUpdateAccessRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string mode = 2;
   */ _define_property(this, "mode", ""), /**
   * @generated from field: repeated string actions = 3;
   */ _define_property(this, "actions", []), /**
   * @generated from field: repeated string roles = 4;
   */ _define_property(this, "roles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminUpdateAccessRuleRequest, "runtime", proto3);
_define_property(AdminUpdateAccessRuleRequest, "typeName", "mono.authz.v1.AdminUpdateAccessRuleRequest");
_define_property(AdminUpdateAccessRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminUpdateAccessRuleResponse
 */ export class AdminUpdateAccessRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminUpdateAccessRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUpdateAccessRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUpdateAccessRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminUpdateAccessRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AccessRuleView rule = 1;
   */ _define_property(this, "rule", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminUpdateAccessRuleResponse, "runtime", proto3);
_define_property(AdminUpdateAccessRuleResponse, "typeName", "mono.authz.v1.AdminUpdateAccessRuleResponse");
_define_property(AdminUpdateAccessRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rule",
            kind: "message",
            T: AccessRuleView
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminResetAccessRuleRequest
 */ export class AdminResetAccessRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdminResetAccessRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminResetAccessRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminResetAccessRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminResetAccessRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminResetAccessRuleRequest, "runtime", proto3);
_define_property(AdminResetAccessRuleRequest, "typeName", "mono.authz.v1.AdminResetAccessRuleRequest");
_define_property(AdminResetAccessRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.authz.v1.AdminResetAccessRuleResponse
 */ export class AdminResetAccessRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdminResetAccessRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminResetAccessRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminResetAccessRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdminResetAccessRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.authz.v1.AccessRuleView rule = 1;
   */ _define_property(this, "rule", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdminResetAccessRuleResponse, "runtime", proto3);
_define_property(AdminResetAccessRuleResponse, "typeName", "mono.authz.v1.AdminResetAccessRuleResponse");
_define_property(AdminResetAccessRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rule",
            kind: "message",
            T: AccessRuleView
        }
    ]));
